<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">交易定价表</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="tradepriceForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="产品名称" prop="name">
              <Input v-model="form.name" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="产品码" prop="code">
              <Input v-model="form.code" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="定价(分)" prop="price">
              <Input v-model="form.price" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="租户" prop="tenantId">
              <Input v-model="form.tenantId" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'tradeprice-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        id: [
          { required: true, message: 'ID不允许为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '交易名称不允许为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '交易码不允许为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '定价（分）不允许为空', trigger: 'blur' }
        ],
        tenantId: [
          { required: true, message: '租户ID不允许为空', trigger: 'blur' }
        ],
        crtUserId: [
          { required: true, message: '创建用户Id不允许为空', trigger: 'blur' }
        ],
        crtTime: [
          { required: true, message: '创建时间不允许为空', trigger: 'blur' }
        ],
        mdfUserId: [
          { required: true, message: '修改人不允许为空', trigger: 'blur' }
        ],
        mdfTime: [
          { required: true, message: '修改时间不允许为空', trigger: 'blur' }
        ],
        unique: [
          { required: true, message: 'Unique不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.tradepriceForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('tradeprice', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('tradeprice', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
